/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * (tsType: Omit<ContractTypeWithRelations, \'fcmMessageId\' | \'fcmToken\'>, schemaOptions: { includeRelations: true, exclude: [ \'fcmMessageId\', \'fcmToken\' ] })
 */
export interface ContractTypeExcludingFcmMessageIdFcmTokenWithRelations { 
    deleted?: boolean;
    deletedOn?: string | null;
    deletedBy?: string | null;
    createdOn?: string;
    modifiedOn?: string;
    createdBy?: number;
    modifiedBy?: number;
    id?: string;
    name: string;
    code: string;
    description?: string;
    color?: string;
}

